export default __webpack_public_path__ + "static/media/medical-advice-icon.677c90b2.svg";